import React from "react";
import { Switch, Route } from "react-router-dom";

import MainPage from "./MainPage/MainPage";
import FishMarketDetailScreen from "./MainPage/FishDetail";
import Events from "./MainPage/Events";
import EventDetail from "./MainPage/EventDetail";
import Article from "./MainPage/Article";
import FishermanList from "./MainPage/FishermanList";

const MainRoutes = () => (
  <Switch>
    <Route exact path="/" component={Article} />
    <Route path="/fishmarket" component={MainPage} />
    <Route path="/fish-detail" component={FishMarketDetailScreen} />
    <Route path="/events" component={Events} />
    <Route path="/event-detail" component={EventDetail} />
    <Route path="/article" component={Article} />
    <Route path="/fisherman-list" component={FishermanList} />
  </Switch>
);

export default MainRoutes;



// WEBPACK FOOTER //
// ./src/containers/PublicRoutes.js